__turbopack_context__.v({
  "fallback": "ForumAvatar-module-scss-module__uESK7q__fallback",
  "image": "ForumAvatar-module-scss-module__uESK7q__image",
  "root": "ForumAvatar-module-scss-module__uESK7q__root",
});
